<template>
  <v-switch
    v-model="selectArea"
    dense
    hide-details
    :label="`${selectArea ? labels.back : labels.select}`"
    @change="selectAreaChanged"
  ></v-switch>
</template>

<script>
import translate from '@/utils/genTable/multilanguageHelper.js'
import store from '@/store/store'
import { mapState } from 'vuex'
import { gmapApi } from 'vue2-google-maps'
import mapMixin from '../mapMixin.js'
import { allVehicleStatuses } from '../../../utils/globalConstants'

export default {
  name: 'RealTimeSelectAreaComponent',
  mixins: [mapMixin],
  data() {
    return {
      selectArea: false,
      labels: {
        select: translate('Select', 'mapFilters'),
        back: translate('Back', 'mapFilters')
      },
      selector: null,
      googleDrawingManager: null
    }
  },
  computed: {
    ...mapState('selectArea', [
      'enableSelectArea',
      'polygon',
      'polylines',
      'selectedVehiclesToDisplay',
      'mapObject'
    ]),
    ...mapState('map', ['vehicles']),
    ...mapState('filters', ['filters']),
    google: gmapApi,
    noOneFocused() {
      let noOneFocused = true

      this.vehicles.forEach(vehicle => {
        if (vehicle.focused) {
          noOneFocused = false
        }
      })
      return noOneFocused
    }
  },
  methods: {
    selectAreaChanged() {
      let selectedVehicleStatuses = this.filters.vehicleStatus
      let selectedVehicleStatusesIds = allVehicleStatuses.filter(x => selectedVehicleStatuses.includes(x.Status)).map(x => x.Id)

      if (this.mapType == 1) {
        if (this.selectArea) {
          this.googleDrawingManager = new this.google.maps.drawing.DrawingManager(
            {
              drawingControl: false
            }
          )

          this.googleDrawingManager.setOptions({
            drawingMode: this.google.maps.drawing.OverlayType.RECTANGLE
          })

          this.googleDrawingManager.setMap(this.mapObject.$mapObject)

          this.google.maps.event.addListener(
            this.googleDrawingManager,
            'overlaycomplete',
            event => {
              store.dispatch('selectArea/emptyVehiclesForDisplay')
              this.vehicles.forEach(vehicle => {
                const latLng = new this.google.maps.LatLng(
                  vehicle.latitude,
                  vehicle.longitude
                )
                const contains = event.overlay.getBounds().contains(latLng)

                if (
                  ((contains && vehicle.focused) ||
                  (contains && this.noOneFocused)) &&
                  (selectedVehicleStatusesIds.includes(vehicle.color))
                ) {
                  store.dispatch('selectArea/addVehicleForDisplay', vehicle)
                }
              })

              if (this.selectedVehiclesToDisplay.length) {
                store.dispatch('selectArea/showResultDialog', true)
              }
              event.overlay.setMap(null)
            }
          )
        } else {
          this.googleDrawingManager.setMap(null)
        }
      } else {
        this.extendLeafletMap()

        this.selector = new this.extendedDrawFunctionality(this.mapObject, {
          onDrawEnd: this.displayFoundVehicles
        })

        if (this.selectArea) {
          this.selector.addHooks()
        } else {
          this.selector.removeHooks()
        }
      }
    },
    displayFoundVehicles() {
      store.dispatch('selectArea/emptyVehiclesForDisplay')
      var selectedVehicles = this.selector.getSelectedMarkers()

      selectedVehicles.forEach(vehicle => {
        // marker options.id is imei-or-vehicleId (see LeafletRealTimeMapComponent :options)
        var found = this.vehicles.find(v => (v.imei || v.vehicleId) === vehicle.options.id)

        if (found) {
          store.dispatch('selectArea/addVehicleForDisplay', found)
        }
      })

      if (this.selectedVehiclesToDisplay.length) {
        store.dispatch('selectArea/showResultDialog', true)
      }
    },
    extendLeafletMap() {
      var that = this
      this.extendedDrawFunctionality = window.L.Handler.extend({
        options: {
          onDrawStart: null,
          onDrawEnd: null,
          color: 'green',
          weight: 2,
          dashArray: '5, 5, 1, 5',
          selCursor: 'crosshair',
          normCursor: ''
        },
        initialize: function(map, options) {
          this._map = map
          this._pre_latlon = ''
          this._post_latlon = ''
          this._ARR_latlon_line = []
          this._ARR_latlon = []

          this.area_pologon_layers = []

          this._area_line = ''
          this._area_line_new = ''

          window.L.setOptions(this, options)
        },
        addHooks: function() {
          this._map.mapObject.on('mousedown', this._doMouseDown, this)
          this._map.mapObject.on('mouseup', this._doMouseUp, this)
          this._map.mapObject.dragging.disable()
          this._map.mapObject._container.style.cursor = this.options.selCursor
        },
        removeHooks: function() {
          store.dispatch('selectArea/emptyPolygonAndPolylines')
          this._map.mapObject.off('mousemove')
          this._map.mapObject.off('mousedown')
          this._map.mapObject.off('mouseup')
          this._map.mapObject._container.style.cursor = this.options.normCursor

          this._map.mapObject.dragging.enable()
        },
        _doMouseDown: function() {
          if (this.options.onDrawStart) this.options.onDrawStart()

          this._ARR_latlon = []
          this._area_pologon = ''
          this._area_line_new = ''
          this._area_line = ''

          this._map.mapObject.on('mousemove', this._doMouseMove, this)
        },
        _doMouseUp: function() {
          this._pre_latlon = ''
          this._post_latlon = ''
          this._ARR_latlon_line = []

          store.dispatch('selectArea/assignPolygonValue', {
            coordinates: this._ARR_latlon,
            color: this.options.color,
            visible: true
          })

          this._map.mapObject.off('mousemove')

          if (this.options.onDrawEnd) this.options.onDrawEnd()
        },
        _doMouseMove: function(ev) {
          this._ARR_latlon.push(ev.latlng)
          if (this._pre_latlon == '' || this._pre_latlon == 'undefined') {
            this._pre_latlon = ev.latlng
            this._ARR_latlon_line.push(this._pre_latlon)
          } else if (
            this._pre_latlon != '' &&
            (this._post_latlon == '' || this._post_latlon == 'undefined')
          ) {
            this._post_latlon = ev.latlng
            this._ARR_latlon_line.push(this._post_latlon)
          } else {
            this._pre_latlon = this._post_latlon
            this._post_latlon = ev.latlng
            this._ARR_latlon_line.push(this._pre_latlon)
            this._ARR_latlon_line.push(this._post_latlon)
          }

          if (this._pre_latlon != '' && this._post_latlon != '') {
            if (this._area_line_new == '' && this._area_line == '') {
              store.dispatch('selectArea/assignPolylinesValue', {
                coordinates: [this._ARR_latlon_line],
                color: this.options.color,
                weight: this.options.weight,
                dashArray: this.options.dashArray,
                visible: true
              })
            }

            if (this._area_line_new == '' && this.area_line != '') {
              store.dispatch('selectArea/emptyPolylines')
              store.dispatch('selectArea/assignPolylinesValue', {
                coordinates: [this._ARR_latlon_line],
                color: this.options.color,
                weight: this.options.weight,
                dashArray: this.options.dashArray,
                visible: true
              })
            }

            if (this._area_line_new != '' && this._area_line != '') {
              store.dispatch('selectArea/emptyPolylines')
              this._area_line_new = ''

              store.dispatch('selectArea/assignPolylinesValue', {
                coordinates: [this._ARR_latlon_line],
                color: this.options.color,
                weight: this.options.weight,
                dashArray: this.options.dashArray,
                visible: true
              })
            }
          }
        },
        getSelectedMarkers: function() {
          var foundLayers = []
          this._map.mapObject.eachLayer(function(layer) {
            if (layer instanceof window.L.Marker) {
              var polygonPoints = that.polygon.coordinates
              var x = layer.getLatLng().lat
              var y = layer.getLatLng().lng

              var inside = false
              for (
                var i = 0, j = polygonPoints.length - 1;
                i < polygonPoints.length;
                j = i++
              ) {
                var xi = polygonPoints[i].lat,
                  yi = polygonPoints[i].lng
                var xj = polygonPoints[j].lat,
                  yj = polygonPoints[j].lng

                var intersect =
                  yi > y != yj > y &&
                  x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
                if (intersect) inside = !inside
              }

              if (inside) {
                foundLayers.push(layer)
              }
            }
          })

          return foundLayers
        }
      })
    }
  }
}
</script>
